

import BasicList from "../../../basic-list";

export default class DepartmentsPage extends BasicList {

}